import loadingGif from '../../assets/img/loading.gif';
import React, { useState, useEffect, Fragment } from "react";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import moment from 'moment';
import PageTitle from "../../Components/PageTitle.js";
import Swal from 'sweetalert2';
import { decodeToken, isExpired } from "react-jwt";
import 'react-tooltip/dist/react-tooltip.css';
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import GridAlisSatis from './Proje/GridAlisSatis.js';
import GridMasraf from './Proje/GridMasraf.js';
import GridOdeme  from './Proje/GridOdeme.js';
import GridSonuc from './Proje/GridSonuc.js';

const Proje = () => {
    const [showProje, setShowProje] = useState(false);
    const handleCloseProje = () => setShowProje(false);
    const handleShowProje = () => setShowProje(true);

    const [loading, setLoading] = useState(false);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [sort, setSort] = useState("");

    const [projeNoKriter, setProjeNoKriter] = useState("");
    const [cariIdSaticiKriter, setCariIdSaticiKriter] = useState(0);
    const [cariIdMusteriKriter, setCariIdMusteriKriter] = useState(0);
    const [olusturulmaZamaniKriter, setOlusturulmaZamaniKriter] = useState([null, null]);
    const [olusturulmaZamani1Kriter, olusturulmaZamani2Kriter] = olusturulmaZamaniKriter;

    const [projeIdData, setProjeIdData] = useState(0);
    const [projeNoData, setProjeNoData] = useState("");
    const [cariIdSaticiData, setCariIdSaticiData] = useState(0);
    const [cariIdMusteriData, setCariIdMusteriData] = useState(0);

    const [dataCariSatici, setDataCariSatici] = useState([]);
    const [dataCariMusteri, setDataCariMusteri] = useState([]);
    const [data, setData] = useState([]);

    const [tab, setTab] = useState('Alis');

    const [pageNo, setPageNo] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);

    const days = ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct']
    const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']

    const datePickerLocale = {
      localize: {
        day: n => days[n],
        month: n => months[n]
      },
      formatLong: {
        date: () => 'dd.MM.yyyy'
      }
    }
    
    //const workbook = new Excel.Workbook();

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);

            setShowProje(false);

            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const handleOlusturulmaZamaniKriterChange = (e) => {
        if (tokenYenile() === false) {
            return;
        }
        setPageNo(1);
        setOlusturulmaZamaniKriter(e);
    };

    const handleSortClick = async (e) => {
        if (tokenYenile() === false) {
            return;
        }

        let temp = sort;

        const name = e.target.name;

        if (temp.startsWith(name)) {
            if (temp === name) {
                temp = name + " DESC";
            } else {
                temp = "";
            }            
        } else {
            temp = name;
        }

        setPageNo(1);
        setSort(temp);
    };

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true) {
            getData();
        }
    }, [cariIdSaticiKriter, cariIdMusteriKriter, pageNo, pageSize, sort]);

    function createDateAsUTC(date) {
        try {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        } catch (error) {
            return null;
        }
    }

    const Sorgula = async (e) => {
        if (tokenYenile() === false) {
            return;
        }

        if (pageNo !== 1) {
            await setPageNo(1);
        } else {
            await getData();
        }
    }

    const handlePageSize = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
        await setPageSize(e);
    }

    const handlePageNo = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(e);
    }

    const NavIlk = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
    }

    const NavGeri = async () => {
        if ((pageNo - 1) >= 1) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(pageNo - 1);
        }
    }

    const NavIleri = async () => {
        if ((Number(pageNo) + 1) <= lastPage) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(Number(pageNo) + 1);
        }
    }

    const NavSon = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(lastPage);
    }

    const getAcilisData = async () => {
        if (tokenYenile() === false) {
            return;
        }

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Sil"));

            setDataCariSatici((await axios.get(settings.ApiUrl + "Lookup/GetCari/2", { headers: AuthService.getHeaders() })).data.value);
            setDataCariMusteri((await axios.get(settings.ApiUrl + "Lookup/GetCari/1", { headers: AuthService.getHeaders() })).data.value);

            await getData();
        }
    }

     ////////////////////// Proje /////////////////////////

    const getData = async () => {
        const kriter = JSON.stringify({
            "id": 0,
            "projeNo": projeNoKriter,
            "cariIdSatici": Number(cariIdSaticiKriter),
            "cariIdMusteri": Number(cariIdMusteriKriter),
            "olusturulmaZamani1": olusturulmaZamani1Kriter === null ? "" : moment(createDateAsUTC(olusturulmaZamani1Kriter)).format('DD.MM.YYYY'),
            "olusturulmaZamani2": olusturulmaZamani2Kriter === null ? "" : moment(createDateAsUTC(olusturulmaZamani2Kriter)).format('DD.MM.YYYY'),
            "sort": sort,
            "pageNo": pageNo,
            "pageSize": pageSize
        });

        try {
            setLoading(true);

            const res = await axios.post(settings.ApiUrl + 'Proje/GetProjeList', kriter, { headers: AuthService.getHeaders() });

            setRowCount(res.data.rowCount);
            setLastPage(Math.ceil(res.data.rowCount / pageSize));
            setData(res.data.value);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const handleCariIdMusteriData = async (e) => {
        setCariIdMusteriData(e);
    }

    const EkleProje = async () => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            setLoading(true);

            setProjeIdData(0);
            setProjeNoData("");
            setCariIdSaticiData(0);
            setCariIdMusteriData(0);

            setTab("Alis");

            handleShowProje();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const DegistirProje = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            setLoading(true);

            const res = await axios.get(settings.ApiUrl + 'Proje/GetProje/' + id, { headers: AuthService.getHeaders() });

            if (res) {
                setProjeIdData(res.data.value.id);
                setProjeNoData(res.data.value.projeNo);
                setCariIdSaticiData(res.data.value.cariIdSatici);
                setCariIdMusteriData(res.data.value.cariIdMusteri);

                setTab("Alis");

                setProjeIdData(id);

                handleShowProje();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const KaydetProje = async () => {
        if (tokenYenile() === false) {
            return;
        }

        if (projeNoData === "" || Number(cariIdSaticiData) === 0 || Number(cariIdMusteriData) === 0) {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları giriniz", icon: "error" });
        } else {
            try {
                setLoading(true);

                const data = JSON.stringify({
                    "id": projeIdData,
                    "projeNo": projeNoData,
                    "cariIdSatici": Number(cariIdSaticiData),
                    "cariIdMusteri": Number(cariIdMusteriData),
                    "olusturulmaZamani": "2025-07-20"
                });

                const result = await axios.post(settings.ApiUrl + 'Proje/InsertOrUpdateProje/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success === true) {
                        await getData();

                        setProjeIdData(Number(result.data.value));

                        toast.success("Kaydedildi");
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            } finally {
                setLoading(false);
            }
        }
    }
    
    const SilProje = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    setLoading(true);

                    const resultGet = await axios.get(settings.ApiUrl + 'Proje/GetProje/' + id, { headers: AuthService.getHeaders() });

                    if (resultGet && resultGet.data) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Proje/DeleteProje/', [resultGet.data.value], { headers: AuthService.getHeaders() });

                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                getData();
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);        
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                } finally {
                    setLoading(false);
                }
            }
        });
    }

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>
            
            <PageTitle></PageTitle>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div>
                                <div className="card info-card mb-3">
                                    {
                                        loading ?
                                            <div className="progressBackground">
                                                <div className="progressPopup">
                                                    <img alt="Bekleyiniz..." src={loadingGif} />
                                                </div>
                                            </div>
                                            :
                                            ''
                                    }
                                    <div className="table-responsive" style={{border:"0px solid silver"}}>
                                        <table className="table table-bordered table-hover table-sm mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{ textAlign: "center" }}><button name="ProjeNo" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Proje No</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="CariIdSatici" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Satıcı</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="CariIdMusteri" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Müşteri</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="OlusturulmaZamani" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Oluşturulma Zamanı</button></th>
                                                    <th style={{ textAlign: "center" }}>
                                                        { yetkiEkle === true ? <button className="btn btn-sm btn-icon text-success" onClick={() => EkleProje()}><i className="bi bi-plus-circle"></i></button> : ''}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th style={{ textAlign: "center" }}><input name="ProjeNoKriter" type="text" className="form-control form-control-xsm" value={projeNoKriter} onChange={(e) => setProjeNoKriter(e.target.value)} ></input></th>
                                                    <th style={{ textAlign: "center" }}>
                                                        <select className="form-select form-select-sm" value={cariIdSaticiKriter} onChange={(e) => setCariIdSaticiKriter(e.target.value)}>
                                                            <option value="0"></option>
                                                            {
                                                                dataCariSatici && dataCariSatici.length > 0 ?
                                                                dataCariSatici.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                                    )
                                                                })
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                    </th>
                                                    <th style={{ textAlign: "center" }}>
                                                        <select className="form-select form-select-sm" value={cariIdMusteriKriter} onChange={(e) => setCariIdMusteriKriter(e.target.value)}>
                                                            <option value="0"></option>
                                                            {
                                                                dataCariMusteri && dataCariMusteri.length > 0 ?
                                                                dataCariMusteri.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                                    )
                                                                })
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                    </th>
                                                    <th style={{ textAlign: "center" }}><DatePicker className="form-control form-control-xsm text-center" calendarStartDay={1} todayButton="Bugün" dateFormat="dd.MM.yyyy" locale={datePickerLocale} selectsRange={true} isClearable={false} startDate={olusturulmaZamani1Kriter} endDate={olusturulmaZamani2Kriter} onChange={(update) => { handleOlusturulmaZamaniKriterChange(update); }} /></th>
                                                    <th style={{ textAlign: "center" }}><button className="btn btn-sm btn-icon text-success" type='submit' onClick={() => Sorgula()}><i className="bi bi-search"></i></button></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data && data.length > 0 ?
                                                        data.map((itemProje, indexProje) => {
                                                            return (
                                                                <tr key={"Proje" + indexProje}>
                                                                    <td align="center">{itemProje.projeNo}</td>
                                                                    <td align="center">{itemProje.cariSatici}</td>
                                                                    <td align="center">{itemProje.cariMusteri}</td>
                                                                    <td align="center">{itemProje.olusturulmaZamani === null ? "" : moment(itemProje.olusturulmaZamani).format('DD.MM.YYYY HH:mm')}</td>
                                                                    <td align="center">
                                                                        <div className='btn-group'>
                                                                            { yetkiDegistir === true ? <button className="btn btn-sm btn-icon text-info" onClick={() => DegistirProje(itemProje.id)}><i className="bi bi-pencil"></i></button> : ''}
                                                                            { yetkiSil === true ? <button className="btn btn-sm btn-icon text-danger" onClick={() => SilProje(itemProje.id)}><i className="bi bi-trash"></i></button> : ''}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                        :
                                                        <tr>
                                                            <td align="center" colSpan="5">
                                                                Kayıt bulunamadı
                                                            </td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row" style={{ placeItems: "center", padding: "8px" }}>
                                        <div className="col-md-4" style={{ display: "ruby" }}>
                                            <span className="badge bg-primary">{rowCount + " kayıt"}</span>
                                        </div>
                                        <div className="col-md-4" style={{ textAlign: "-webkit-center" }}>
                                            <div style={{ display: "flex", width: "224px" }}>
                                                <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIlk()}><i className="bi bi-caret-left-fill"></i></button>
                                                <button className="btn btn-sm btn-icon text-info" onClick={async () => NavGeri()}><i className="bi bi-caret-left"></i></button>
                                                <div className="input-group">
                                                    <input type="text" className="form-control form-control-xsm text-center" value={pageNo} onChange={(e) => handlePageNo(e.target.value)}></input>
                                                    <div className="form-control form-control-xsm text-center" style={{ borderLeft: "none" }}>{" / " + lastPage}</div>
                                                </div>
                                                <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIleri()}><i className="bi bi-caret-right"></i></button>
                                                <button className="btn btn-sm btn-icon text-info" onClick={async () => NavSon()}><i className="bi bi-caret-right-fill"></i></button>
                                            </div>
                                        </div>
                                        <div className="col-md-4" style={{ textAlign: "-webkit-right" }}>
                                            <select className="form-select form-select-xsm" style={{ width: "128px" }} value={pageSize} onChange={async (e) => handlePageSize(e.target.value)}>
                                                <option value="5">5 kayıt göster</option>
                                                <option value="10">10 kayıt göster</option>
                                                <option value="25">25 kayıt göster</option>
                                                <option value="50">50 kayıt göster</option>
                                                <option value="100">100 kayıt göster</option>
                                                <option value="250">250 kayıt göster</option>
                                                <option value="500">500 kayıt göster</option>
                                                <option value="1000">1000 kayıt göster</option>
                                                <option value="5000">5000 kayıt göster</option>
                                                <option value="10000">10000 kayıt göster</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        :
                        ""
            }

            <Modal show={showProje} onHide={handleCloseProje} fullscreen={true}>
                <Modal.Header closeButton>
                    <Modal.Title>Proje Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='card'>
                        <div className='card-body'>
                            <h5 className='card-title'>Proje Genel Bilgileri</h5>
                            <div className='row'>
                                <div className='col-md-2'>
                                    <div className="form-group">
                                        <label>Proje No<span style={{ color: "red", paddingLeft: "4px" }}>*</span></label>
                                        <input  type="text" className="form-control form-control-sm" value={projeNoData} onChange={(e) => setProjeNoData(e.target.value)}></input>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className="form-group form-group-sm">
                                        <label>Satıcı<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                        <select className="form-select form-select-sm" value={cariIdSaticiData} onChange={(e) => setCariIdSaticiData(e.target.value)}>
                                            <option value="0"></option>
                                            {
                                                dataCariSatici && dataCariSatici.length > 0 ?
                                                dataCariSatici.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                    )
                                                })
                                                :
                                                null
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className="form-group">
                                        <label>Müşteri<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                        <select className="form-select form-select-sm" value={cariIdMusteriData} onChange={(e) => handleCariIdMusteriData(e.target.value)}>
                                            <option value="0"></option>
                                            {
                                                dataCariMusteri && dataCariMusteri.length > 0 ?
                                                dataCariMusteri.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                    )
                                                })
                                                :
                                                null
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-2'>
                                    <button className="btn btn-success mt-3" onClick={() => KaydetProje()}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul className="nav nav-tabs" style={{position:"relative", zIndex:"1", borderWidth:"0px"}}>
                        {
                            projeIdData !== 0 ?
                                <React.Fragment>
                                    <li className="nav-item">
                                        <button style={{border:"none"}} className={tab === "Alis" ? "nav-link active" : "nav-link"} onClick={() => setTab("Alis")}>Alış</button>
                                    </li>
                                    <li className="nav-item">
                                        <button style={{border:"none"}} className={tab === "OdemeAlis" ? "nav-link active" : "nav-link"} onClick={() => setTab("OdemeAlis")}>Alış Ödeme</button>
                                    </li>
                                    <li className="nav-item">
                                        <button style={{border:"none"}} className={tab === "Satis" ? "nav-link active" : "nav-link"} onClick={() => setTab("Satis")}>Satış</button>
                                    </li>
                                    <li className="nav-item">
                                        <button style={{border:"none"}} className={tab === "OdemeSatis" ? "nav-link active" : "nav-link"} onClick={() => setTab("OdemeSatis")}>Satış Ödeme</button>
                                    </li>
                                    {/* <li className="nav-item">
                                        <button style={{border:"none"}} className={tab === "Kar" ? "nav-link active" : "nav-link"} onClick={() => setTab("Kar")}>Kar</button>
                                    </li> */}
                                    <li className="nav-item">
                                        <button style={{border:"none"}} className={tab === "Masraf" ? "nav-link active" : "nav-link"} onClick={() => setTab("Masraf")}>Masraf</button>
                                    </li>
                                    <li className="nav-item">
                                        <button style={{border:"none"}} className={tab === "OdemeMasraf" ? "nav-link active" : "nav-link"} onClick={() => setTab("OdemeMasraf")}>Masraf Ödeme</button>
                                    </li>
                                    <li className="nav-item">
                                        <button style={{border:"none"}} className={tab === "Sonuc" ? "nav-link active" : "nav-link"} onClick={() => setTab("Sonuc")}>Proje Özeti</button>
                                    </li>
                                </React.Fragment>
                                :
                                ""
                        }
                    </ul>

                    {
                        tab === "Alis" && projeIdData !== 0 ?
                            <GridAlisSatis projeId={projeIdData} cariIdMusteri={cariIdMusteriData} alisSatisKar={1}></GridAlisSatis>
                            :
                            ""
                    }

                    {
                        tab === "OdemeAlis" && projeIdData !== 0 ?
                            <GridOdeme projeId={projeIdData} alisSatisMasrafKar={1}></GridOdeme>
                            :
                            ""
                    }

                    {
                        tab === "Satis" && projeIdData !== 0 ?
                            <GridAlisSatis projeId={projeIdData} cariIdMusteri={cariIdMusteriData} alisSatisKar={2}></GridAlisSatis>
                            :
                            ""
                    }

                    {
                        tab === "OdemeSatis" && projeIdData !== 0 ?
                            <GridOdeme projeId={projeIdData} alisSatisMasrafKar={2}></GridOdeme>
                            :
                            ""
                    }

                    {/* {
                        tab === "Kar" && projeIdData !== 0 ?
                            <GridAlisSatis projeId={projeIdData} cariIdMusteri={cariIdMusteriData} alisSatisKar={3}></GridAlisSatis>
                            :
                            ""
                    } */}

                    {
                        tab === "Masraf" && projeIdData !== 0 ?
                            <GridMasraf projeId={projeIdData}></GridMasraf>
                            :
                            ""
                    }

                    {
                        tab === "OdemeMasraf" && projeIdData !== 0 ?
                            <GridOdeme projeId={projeIdData} alisSatisMasrafKar={3}></GridOdeme>
                            :
                            ""
                    }

                    {
                        tab === "Sonuc" && projeIdData !== 0 ?
                            <GridSonuc projeId={projeIdData}></GridSonuc>
                            :
                            ""
                    }
                </Modal.Body>
            </Modal>
        </Fragment>
    );
};

export default Proje;